<template>

  <div class="page-wrap">

    <el-alert

      title="分别配置教师讲义导出与学生错题本导出的默认商品（金额、次数）。教师可在「管理员管理」中设置专属单次支付金额。"

      type="info"

      show-icon

      :closable="false"

      style="margin-bottom:16px"

    />



    <el-card shadow="never" header="教师讲义导出" v-loading="teacherLoading" style="margin-bottom:16px">

      <div v-if="teacherForm.id">

        <el-form :model="teacherForm" :rules="rules" ref="teacherFormRef" label-width="120px" style="max-width:520px">

          <el-form-item label="商品名称" prop="name">

            <el-input v-model="teacherForm.name" maxlength="100" show-word-limit />

          </el-form-item>

          <el-form-item label="支付金额（元）" prop="price">

            <el-input-number v-model="teacherForm.price" :min="0.01" :max="99999" :step="0.1" :precision="2" style="width:180px" />

          </el-form-item>

          <el-form-item label="包含导出次数" prop="exportCount">

            <el-input-number v-model="teacherForm.exportCount" :min="1" :max="9999" :step="1" style="width:180px" />

          </el-form-item>

          <el-form-item label="商品说明">

            <el-input v-model="teacherForm.description" type="textarea" :rows="2" maxlength="255" show-word-limit />

          </el-form-item>

          <el-form-item label="上架状态">

            <el-switch v-model="teacherForm.status" :active-value="1" :inactive-value="0" active-text="上架" inactive-text="下架" />

          </el-form-item>

          <el-form-item>

            <el-button type="primary" :loading="teacherSaving" @click="saveTeacherProduct">保存设置</el-button>

          </el-form-item>

        </el-form>

      </div>

      <el-empty v-else description="暂无教师导出商品，请联系技术人员初始化数据" />

    </el-card>



    <el-card shadow="never" header="学生错题本导出" v-loading="studentLoading">

      <div v-if="studentForm.id">

        <el-form :model="studentForm" :rules="rules" ref="studentFormRef" label-width="120px" style="max-width:520px">

          <el-form-item label="商品名称" prop="name">

            <el-input v-model="studentForm.name" maxlength="100" show-word-limit />

          </el-form-item>

          <el-form-item label="支付金额（元）" prop="price">

            <el-input-number v-model="studentForm.price" :min="0.01" :max="99999" :step="0.1" :precision="2" style="width:180px" />

          </el-form-item>

          <el-form-item label="包含导出次数" prop="exportCount">

            <el-input-number v-model="studentForm.exportCount" :min="1" :max="9999" :step="1" style="width:180px" />

          </el-form-item>

          <el-form-item label="商品说明">

            <el-input v-model="studentForm.description" type="textarea" :rows="2" maxlength="255" show-word-limit />

          </el-form-item>

          <el-form-item label="上架状态">

            <el-switch v-model="studentForm.status" :active-value="1" :inactive-value="0" active-text="上架" inactive-text="下架" />

          </el-form-item>

          <el-form-item>

            <el-button type="primary" :loading="studentSaving" @click="saveStudentProduct">保存设置</el-button>

          </el-form-item>

        </el-form>

      </div>

      <el-empty v-else description="暂无学生错题本导出商品，请联系技术人员初始化数据" />

    </el-card>

  </div>

</template>



<script>

import request from '../../utils/request'



const emptyForm = () => ({

  id: null,

  name: '',

  price: 9.9,

  exportCount: 10,

  description: '',

  status: 1

})



export default {

  name: 'SystemExportBilling',

  data() {

    return {

      teacherLoading: false,

      studentLoading: false,

      teacherSaving: false,

      studentSaving: false,

      teacherForm: emptyForm(),

      studentForm: emptyForm(),

      rules: {

        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],

        price: [{ required: true, message: '请输入支付金额', trigger: 'change' }],

        exportCount: [{ required: true, message: '请输入导出次数', trigger: 'change' }]

      }

    }

  },

  created() {

    this.loadTeacherProduct()

    this.loadStudentProduct()

  },

  methods: {

    fillForm(item) {

      if (!item) return emptyForm()

      return {

        id: item.id,

        name: item.name || '',

        price: Number(item.price) || 0,

        exportCount: Number(item.exportCount) || 1,

        description: item.description || '',

        status: item.status == null ? 1 : item.status

      }

    },

    loadTeacherProduct() {

      this.teacherLoading = true

      request.get('/export-billing/products').then(list => {

        this.teacherForm = this.fillForm((list || [])[0])

      }).catch(() => {

        this.$message.error('加载教师配置失败')

      }).finally(() => {

        this.teacherLoading = false

      })

    },

    loadStudentProduct() {

      this.studentLoading = true

      request.get('/export-billing/student/products').then(list => {

        this.studentForm = this.fillForm((list || [])[0])

      }).catch(() => {

        this.$message.error('加载学生配置失败')

      }).finally(() => {

        this.studentLoading = false

      })

    },

    saveTeacherProduct() {

      this.$refs.teacherFormRef.validate(valid => {

        if (!valid || !this.teacherForm.id) return

        this.teacherSaving = true

        request.put(`/export-billing/products/${this.teacherForm.id}`, {

          name: this.teacherForm.name,

          price: this.teacherForm.price,

          exportCount: this.teacherForm.exportCount,

          description: this.teacherForm.description,

          status: this.teacherForm.status

        }).then(() => {

          this.$message.success('教师配置保存成功')

          this.loadTeacherProduct()

        }).catch(() => {}).finally(() => {

          this.teacherSaving = false

        })

      })

    },

    saveStudentProduct() {

      this.$refs.studentFormRef.validate(valid => {

        if (!valid || !this.studentForm.id) return

        this.studentSaving = true

        request.put(`/export-billing/student/products/${this.studentForm.id}`, {

          name: this.studentForm.name,

          price: this.studentForm.price,

          exportCount: this.studentForm.exportCount,

          description: this.studentForm.description,

          status: this.studentForm.status

        }).then(() => {

          this.$message.success('学生配置保存成功')

          this.loadStudentProduct()

        }).catch(() => {}).finally(() => {

          this.studentSaving = false

        })

      })

    }

  }

}

</script>



<style scoped>

.page-wrap { padding: 0; }

</style>


